export interface IFirebaseDataTimeStamps {
  auto_order_export: { seconds: number, nanoseconds: number };
  heartbeat: { seconds: number, nanoseconds: number };
  info_tables: { seconds: number, nanoseconds: number };
  multiple_suppliers: { seconds: number, nanoseconds: number };
  reporting: { seconds: number, nanoseconds: number };
  shelf_talkers: { seconds: number, nanoseconds: number };
  stock: { seconds: number, nanoseconds: number };
  suppliers: { seconds: number, nanoseconds: number };
  transactions: { seconds: number, nanoseconds: number };
  units_sold: { seconds: number, nanoseconds: number };
  delcolissuestran?: { seconds: number, nanoseconds: number };
}

export interface IDataTimeStamps {
  auto_order_export: Date;
  heartbeat: Date;
  info_tables: Date;
  multiple_suppliers: Date;
  reporting: Date;
  shelf_talkers: Date;
  stock: Date;
  suppliers: Date;
  transactions: Date;
  units_sold: Date;
  delcolissuestran?: Date;
}
